// x-timeline.js

/*
This script:
- Creates wrapper with heading and buttons to scroll left/right.
- Measures distance between items to determine scroll distance.
- Detects horizontal overflow.
*/

export default function xTimeline() {

  const timelinesAll = document.querySelectorAll(".timeline");

  if (!timelinesAll.length) {
    return;
  }

  const isEnglish = document.documentElement.lang === "en";

  timelinesAll.forEach(timeline => {
    let container;
    let heading;

    // If frontpage
    if (document.body.id === "vrtx-frontpage") {
      // If class is placed on other than box (typically grid-container), return
      if (!timeline.classList.contains("vrtx-frontpage-box")) {
        return;
      }
      heading = timeline.closest(".row").querySelector("h2");
      container = timeline.querySelector(".vrtx-box-content");
    }
    // If article
    else if (document.body.id === "vrtx-structured-article") {
      container = timeline;
      const previousElement = timeline.previousElementSibling;
      if (previousElement && previousElement.tagName === "H2") {
        heading = previousElement;
      }
    }
    // If page type is neither frontpage nor article, return
    else {
      return;
    }

    // Unwrap any <vrtx-component-block> elements within the container
    // (remove the element but keep its children in place)
    // Component blocks occur if using shared text
    // This maintains items as a flat row of divs, which the design relies upon
    const componentBlocksAll = container.querySelectorAll("vrtx-component-block");
    componentBlocksAll.forEach(componentBlock => {
      const parent = componentBlock.parentNode;
      // Move all children of the block to the parent, in the same position
      while (componentBlock.firstChild) {
        parent.insertBefore(componentBlock.firstChild, componentBlock);
      }
      // Remove the empty block element
      parent.removeChild(componentBlock);
      // Debug: log each unwrap occurrence
      console.debug("timeline: unwrapped <vrtx-component-block>");
    });

    // Set tabindex to enable scroll with arrow keys. Recommended wcag solution.
    container.tabIndex = 0;

    // Timeline item (only need first occurence)
    const item = container.querySelector("div");
    if (!item) {
      console.debug("timeline: no items");
      return;
    }

    // Determine distance between items
    let itemDistance;

    function getItemDistance() {
      const itemStyle = window.getComputedStyle(item);
      const itemWidth = parseFloat(itemStyle.width);
      const marginRight = parseFloat(itemStyle.marginRight);
      itemDistance = itemWidth + marginRight;
    }

    // Create prev and next buttons
    const prevButton = document.createElement("button");
    prevButton.className = "prev";
    prevButton.setAttribute("aria-label", isEnglish ? "Previous" : "Forrige");

    const nextButton = document.createElement("button");
    nextButton.className = "next";
    nextButton.setAttribute("aria-label", isEnglish ? "Next" : "Neste");

    // Create container for heading and prev/next buttons

    // Wrapper for buttons
    const buttonWrapper = document.createElement("div");
    buttonWrapper.className = "buttons";

    // Append buttons to the buttonWrapper
    buttonWrapper.append(prevButton, nextButton);

    // Create the heading-prev-next div
    const headingPrevNext = document.createElement("div");
    headingPrevNext.className = "timeline-heading-prev-next";

    // Append heading if it exists
    if (heading) {
      headingPrevNext.append(heading);
    }

    // Append buttonWrapper to headingPrevNext
    headingPrevNext.append(buttonWrapper);

    // Insert headingPrevNext into the DOM before timeline
    timeline.before(headingPrevNext);

    // Prev and next button click events
    prevButton.addEventListener("click", () => {
      getItemDistance();
      container.scrollTo({
        left: container.scrollLeft - itemDistance,
        behavior: "smooth"
      });
    });
    nextButton.addEventListener("click", () => {
      getItemDistance();
      container.scrollTo({
        left: container.scrollLeft + itemDistance,
        behavior: "smooth"
      });
    });

    // Check overflow on load and resize
    function checkOverflow() {
      if (container.scrollWidth === container.offsetWidth) {
        headingPrevNext.classList.add("no-overflow");
      }
      else {
        headingPrevNext.classList.remove("no-overflow");
      }
    }
    checkOverflow();
    window.addEventListener("resize", () => {
      checkOverflow();
    });
  });
}
